import SearchContainer from './search_container'

export default SearchContainer